
export class BasePage<T>
{
  svc_data: T;

 clear() {
     this.unsubscribe();
 }
  unsubscribe() {
    }
    afterPrimarySaved(id: any) {

    }
}
